import { fetchWithAuth } from '@shared/utils/auth';
import { backendUrl } from '@shared/constants/urls/appUrls';

//------------------------------------------------------------------------------
//                  Отправить запрос на восстановление комментария
//------------------------------------------------------------------------------
export const restoreComment = async (commentId) => {
  const url = `${ backendUrl }/api/comments/restore/${commentId}/`;
  const options = {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
  };
  try {
    const response = await fetchWithAuth(url, options);
    if (!response.ok) {
      throw new Error(`Сетевая ошибка при восстановлении комментария: HTTP error! Status: ${ response.status }`);
    }
    return response;
  } catch (error) {
    console.error('Ошибка восстановления комментария: Error fetching get comments list:', error);
    throw error;
  }
};
//xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx